<div id="playlistItemModal">
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button
      type="button"
      mat-icon-button
      class="close"
      (click)="dismiss()"
      aria-label="Click to close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>
  <h4 class="tw-text-center tw-font-semibold">
    {{ isNew ? 'Add' : 'Edit' }} Playlist Item
  </h4>
  <mat-dialog-content
    rvSpinner="playlist-item-modal-loader"
    [rvShowSpinner]="loadingTemplate"
  >
    <form
      [formGroup]="playlistItemForm"
      id="forms.playlistItemForm"
      role="form"
      name="forms.playlistItemForm"
      (keyup.enter)="save()"
      novalidate
    >
      @if (_playlistItem.type !== 'presentation') {
        <div class="tw-mt-5">
          <label class="control-label">Name</label>
          <mat-form-field appearance="outline">
            <input
              type="text"
              matInput
              formControlName="itemName"
              id="itemName"
              placeholder="Item Name"
              [(ngModel)]="_playlistItem.name"
            />
          </mat-form-field>
        </div>
      }

      @if (_playlistItem.type === 'url') {
        <div class="tw-mt-5">
          <label class="control-label">URL</label>
          <rv-url-field
            id="url"
            formControlName="objectReference"
            placeholder="https://"
            [(ngModel)]="_playlistItem.objectReference"
            [allowSkipValidation]="true"
            [acceptedFileTypes]="'ALL'"
            (removeValidationChange)="removeValidationChange($event)"
          />
        </div>
      }

      @if (_playlistItem.type === 'presentation') {
        <div class="tw-flex tw-flex-col tw-w-full">
          <label class="control-label">Presentation</label>
          <div class="tw-flex tw-w-full tw-justify-between">
            <a
              rv-link
              id="presentationName"
              (click)="selectPresentation()"
              (keyup.enter)="$event.stopPropagation()"
              [presentationName]="_playlistItem.objectReference"
            ></a>
            @if (_playlistItem.presentationType === 'HTML Template') {
              <a
                rv-link
                class="tw-min-w-[130px]"
                id="htmlPresentationLink"
                uiSref="apps.editor.templates.edit"
                [uiParams]="{ presentationId: _playlistItem.objectReference }"
                (click)="dismiss()"
                >Edit Presentation</a
              >
            } @else {
              <a
                rv-link
                class="tw-min-w-[130px]"
                id="presentationLink"
                uiSref="apps.editor.workspace.artboard"
                [uiParams]="{ presentationId: _playlistItem.objectReference }"
                (click)="dismiss()"
                >Edit Presentation</a
              >
            }
          </div>
        </div>
      }

      <div class="tw-mt-5 tw-mb-[5px]">
        <label class="control-label" for="playlist-item-pud">Duration</label>
        @if (_playlistItem.type === 'presentation' && playUntilDoneSupported) {
          <div class="flex-row">
            <mat-slide-toggle
              formControlName="playUntilDone"
              [(ngModel)]="_playlistItem.playUntilDone"
              ngDefaultControl
              >Play Until Done</mat-slide-toggle
            >
          </div>
        }
      </div>

      @if (!_playlistItem.playUntilDone) {
        <div>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="number"
              formControlName="duration"
              id="duration"
              [(ngModel)]="_playlistItem.duration"
              required
              min="1"
              placeholder="Enter duration"
            />
            @if (f['duration'].errors?.required) {
              <mat-error>Required</mat-error>
            }
            <span class="duration-suffix" matTextSuffix>Seconds</span>
          </mat-form-field>
        </div>
      }

      <div class="tw-flex tw-flex-col tw-mt-5">
        <label class="control-label">Timeline</label>
        <timeline-textbox
          [timelineObject]="_playlistItem"
          timelineStyle="madero"
          [useColumnLayout]="true"
          inputId="-playlistItem"
        ></timeline-textbox>
      </div>

      <div class="tw-mt-5">
        <label class="control-label">Transition</label>
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="transitionType"
            [(ngModel)]="_playlistItem.transitionType"
          >
            @for (transitionType of transitionTypes; track transitionType[0]) {
              <mat-option [value]="transitionType[0]">{{
                transitionType[1]
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions
    align="end"
    class="tw-gap-2.5 tw-border-solid tw-border-t tw-border-gray-200 tw-pt-5"
  >
    <button rv-button variant="secondary" type="button" (click)="dismiss()">
      Cancel
    </button>
    <button
      rv-button
      type="button"
      id="itemSave"
      (click)="save()"
      [disabled]="saveDisabled()"
    >
      {{ isNew ? 'Add' : 'Apply' }}
    </button>
  </mat-dialog-actions>
</div>
